import React, { useMemo, useEffect, useReducer } from "react";

const initialProviderRequestsState = {
  selectedProviders: [],
  inviteId: 0,
  inviteUrl: '',
  inviteTitle: ''
};

export const ProviderRequestsContext = React.createContext();
export const ProviderRequestsActions = {
  CHANGE_VALUE: 'CHANGE_VALUE',
  REMOVE_VALUE: 'REMOVE_VALUE',
  CHANGE_INVITE_ID_VALUE: 'CHANGE_INVITE_ID_VALUE',
  CHANGE_INVITE_URL_VALUE: 'CHANGE_INVITE_URL_VALUE',
  CHANGE_INVITE_TITLE_VALUE: 'CHANGE_INVITE_TITLE_VALUE',
  PROVIDER_REQUEST_SAVED: 'PROVIDER_REQUEST_SAVED',
};
const providerRequestsReducer =  (state, action) => {
  switch (action.type) {
    case ProviderRequestsActions.CHANGE_VALUE:
      if(!state.selectedProviders.find(item => item.code === action.value)) {
        return { ...state, selectedProviders: [...state.selectedProviders, {'code':action.value, 'name': action.name}]};
      }
    case ProviderRequestsActions.REMOVE_VALUE:
      return { ...state, selectedProviders: [...state.selectedProviders.filter(item => item.code !== action.value)]};
    case ProviderRequestsActions.CHANGE_INVITE_ID_VALUE: {
      return { ...state, inviteId: action.id}}
    case ProviderRequestsActions.CHANGE_INVITE_URL_VALUE: {
      return { ...state, inviteUrl: action.value}}
    case ProviderRequestsActions.CHANGE_INVITE_TITLE_VALUE: {
      return { ...state, inviteTitle: action.value}}
    case ProviderRequestsActions.PROVIDER_REQUEST_SAVED:
      return { ...state, selectedProviders: {...state.selectedProviders, id: action.id}};
    default:
      return state;
  }
};

export const ProviderRequestsProvider =  (props) => {
  const [state, dispatch] = useReducer(providerRequestsReducer, initialProviderRequestsState);
  const contextValue = useMemo(() => {
    return { state, dispatch };
  }, [state, dispatch]);

  return (
    <ProviderRequestsContext.Provider value={contextValue}>
      {props.children}
    </ProviderRequestsContext.Provider>
  )
};
